<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div class="recharge">

      <div class="product-description">
        <p></p>
        <p>请选择需要购买的套餐</p>
        <p></p>
      </div>
      <s-product-list @purchase="purchase"></s-product-list>
    </div>
  </a-layout-content>
</template>

<script>
import Banner from "./banner";
import PaymentResult from "./PaymentResult";
import PaymentInfo from "./PaymentInfo";
import ProductList from "../_ProductList.vue";
export default {
  components: {
    "s-banner": Banner,
    "s-product-list": ProductList
  },
  methods: {
    purchase(productId) {
            // this.$dialog(PaymentResult, {  });return;
      // console.log(productId);
      this.$http
        .post("/createPreOrder", { cid: productId })
        .then(res => {
          if(!res.error){
            this.$dialog(PaymentInfo, { ...res.data });
          }else{
            console.error(res.errorMsg);
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }
};
</script>
<style lang="scss" >
.recharge {
  .product-description {
    display: flex;
    flex-flow: row;
    margin: 60px 0 20px;
    align-items: center;
    justify-content: center;
    p:nth-child(1) {
      margin-left: 30px;
      border-top: 1px solid #e9eef2;
      border-bottom: 1px solid #e9eef2;
      height: 11px;
      &::after {
        content: " ";
        border-bottom: 1px solid #e9eef2;
        width: 315px;
        height: 1px;
        display: inline-block;
        margin-bottom: 10px;
        margin-left: -10px;
      }
    }

    p:nth-child(3) {
      margin-right: 30px;
      border-top: 1px solid #e9eef2;
      border-bottom: 1px solid #e9eef2;
      height: 11px;
      &::after {
        content: " ";
        border-bottom: 1px solid #e9eef2;
        width: 315px;
        height: 1px;
        display: inline-block;
        margin-bottom: 10px;
        margin-right: -10px;
      }
    }

    p:nth-child(2) {
      width: 240px;
      height: 25px;
      color: #333;
      font-size: 22px;
      text-align: center;
    }
  }
  .product-list {
    & > div {
      margin: 0;
      &:not(:last-child) {
        margin-right: 10px;
      }
      & > ul > li {
        width: 230px !important;
      }
    }
  }
}
</style>
